import { useContract, useContractRead } from '@thirdweb-dev/react';

import factoryAbi from 'abis/factory.json';

import { NATIVE_TOKEN_ADDRESS } from '@thirdweb-dev/sdk';
import { useConfig } from '@app/config';

export function usePairData(from: string, to: string) {
  const config = useConfig();
  const { contract } = useContract(config?.CONTRACTS.FACTORY, factoryAbi);
  const token0 = from === NATIVE_TOKEN_ADDRESS ? config?.CONTRACTS.WETH : from;
  const token1 = to === NATIVE_TOKEN_ADDRESS ? config?.CONTRACTS.WETH : to;

  const { data, isLoading } = useContractRead(contract, 'getPair', [
    token0,
    token1
  ]);

  return {
    data,
    isLoading
  };
}
